import {Word} from "./Word";

 export class Adverb extends Word {
    public artikel: any;
    constructor(word:any){
        super(word);
    }
}